import React from "react";

/**
 * Shown at the top of a patient's chart, on every tab, when their medications
 * include a nitrate, digoxin, an anticholinergic or a narcotic, or they said so
 * on the intake form. Provider-facing only; the patient is never shown this.
 *
 * Charcoal with a warning icon rather than red: DESIGN_SYSTEM.md reserves Error
 * red for interface failures and severity red for symptom scores, and has no
 * warning colour. Flagged in the PR rather than invented here.
 *
 * @param alerts from GET /patient/{id}/medication-alerts:
 *               [{ medicationClass, label, matched: [..], reportedByPatient }]
 */
const MedicationAlertBanner = ({ alerts }) => {
  if (!alerts || alerts.length === 0) return null;
  return (
    <div role="alert" style={{ display: "flex", gap: "12px", alignItems: "flex-start", padding: "12px 16px", margin: "12px 0",
                               border: "2px solid var(--youro-charcoal)", borderRadius: "10px", backgroundColor: "var(--youro-card)",
                               color: "var(--youro-charcoal)" }}>
      {/* lucide triangle-alert */}
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0, marginTop: "1px" }}>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
      <div>
        <strong style={{ display: "block", marginBottom: "4px" }}>Medication alert: review before prescribing</strong>
        <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "0.875rem" }}>
          {alerts.map((a) => (
            <li key={a.medicationClass}>
              <strong>{a.label}</strong>
              {a.matched && a.matched.length > 0 && <> — on their medication list: {a.matched.join(", ")}</>}
              {a.reportedByPatient && <> — reported by the patient on the intake form</>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MedicationAlertBanner;
